import { useForm } from "react-hook-form";
import {
  ADDRESS,
  CLIENT_NAME,
  DESCRIPTION,
  ESTIMATED_END_DATE,
  ESTIMATED_START_DATE,
  NAME,
  PROJECT_CATEGORY_ID,
  PROJECT_CODE,
  PROJECT_ID,
  PROJECT_VALUE,
  STATUS,
} from "./consts";
import { useParams } from "react-router-dom";
import { schema, formValues } from "./validations";
import { getRequiredFields, projectStatus } from "@/lib/utils";
import { useGetProjectById, useGetProjectCategories } from "@/services";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { useEffect, useState } from "react";
import { setProjectData } from "@/redux/slices";
import moment from "moment";

const useProjectBasicDtl = () => {
  const { id, action } = useParams();
  const isEdit = action == "edit";
  const dispatch = useDispatch();
  const [keys, setKeys] = useState<any>({
    projectCategoryList: Math.random() * 2,
  });

  const form = useForm<formValues>({
    defaultValues: {
      [NAME]: "",
      [PROJECT_ID]: "",
      [PROJECT_CODE]: "",
      [PROJECT_CATEGORY_ID]: "",
      [ESTIMATED_START_DATE]: "",
      [ESTIMATED_END_DATE]: "",
      [CLIENT_NAME]: "",
      [PROJECT_VALUE]: "",
      [ADDRESS]: "",
      [DESCRIPTION]: "",
      [STATUS]: projectStatus.draft.value,
    },
  });

  const requiredFields = getRequiredFields(schema);

  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  const { data: projectCategoryList, isLoading: isLoadingProjectCategory } =
    useGetProjectCategories({ tenantId: loggedInUserData?.tenantId });

  const { data: projectData, isLoading: isProjectDataLoading } =
    useGetProjectById({ id: id as string, queryParams: { enabled: !!id } });

  useEffect(() => {
    if (projectData?.data) {
      dispatch(setProjectData(projectData?.data));
      form.reset({
        [NAME]: projectData?.data?.[NAME]?.toString() || "",
        [PROJECT_ID]: projectData?.data?.[PROJECT_ID]?.toString() || "",
        [PROJECT_CODE]: projectData?.data?.[PROJECT_CODE]?.toString() || "",
        [PROJECT_CATEGORY_ID]:
          projectData?.data?.[PROJECT_CATEGORY_ID]?.toString() || "",
        [ESTIMATED_START_DATE]: projectData?.data?.[ESTIMATED_START_DATE]
          ? moment(projectData?.data?.[ESTIMATED_START_DATE])
          : "",
        [ESTIMATED_END_DATE]: projectData?.data?.[ESTIMATED_END_DATE]
          ? moment(projectData?.data?.[ESTIMATED_END_DATE])
          : "",
        [CLIENT_NAME]: projectData?.data?.[CLIENT_NAME]?.toString() || "",
        [PROJECT_VALUE]: projectData?.data?.[PROJECT_VALUE]?.toString() || "",
        [ADDRESS]: projectData?.data?.[ADDRESS]?.toString() || "",
        [DESCRIPTION]: projectData?.data?.[DESCRIPTION]?.toString() || "",
        [STATUS]: projectData?.data?.[STATUS]?.toString() || "",
      });
      setKeys({ projectCategoryList: Math.random() * 3 });
    }
  }, [projectData]);

  return {
    form,
    requiredFields,
    isEdit,
    keys,
    projectCategoryList,
    isProjectDataLoading,
    isLoadingProjectCategory
  };
};

export default useProjectBasicDtl;
